// extracted by mini-css-extract-plugin
module.exports = {"container":"sportSection_container__BmXoN","boxDivider":"sportSection_boxDivider__ska0j","boxError":"sportSection_boxError__c4yX8"};